import { CroppingPatternReportModel } from "@agroyaar/sdk";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import NoteBox from "@/shared/components/report-template/presentation/components/common/NoteBox";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import Description from "@/shared/components/report-template/presentation/components/common/Description";

interface CompositeIndexProps {
  croppingPatternReports: CroppingPatternReportModel[];
}

const CompositeIndex = ({ croppingPatternReports }: CompositeIndexProps) => {
  return (
    <ReportTemplate serviceType="CROPPING_PATTERN" pageNumber={2}>
      <div className="w-full flex flex-col gap-6">
        <Title>شاخص ترکیبی کشت برای محصولات منتخب</Title>

        <Description>
          ارزیابی الگوی کشت با در نظر گرفتن پارامترهای مختلف از جمله سازگاری
          اقلیمی و خاکی، نیاز آبی و سایر عوامل مؤثر انجام شده است.
        </Description>

        <NoteBox>
          براساس نتایج این ارزیابی، محصولات{" "}
          <span className="font-semibold text-[18px] leading-[28px] !font-[B-Nazanin] text-president">
            {croppingPatternReports
              .map((cropReport) => cropReport.crop.persianName)
              .join("، ")}
          </span>{" "}
          به ترتیب دارای بالاترین شاخص ترکیبی الگوی کشت هستند و برای کاشت در
          زمین شما به عنوان گزینه‌های پیشنهادی اولویت دارند. این محصولات از نظر
          فنی و اقتصادی بیشترین تناسب را با شرایط زمین مورد نظر دارند.
        </NoteBox>

        <div className="flex items-start gap-4 mt-8">
          <div className="flex flex-col justify-center items-center gap-3 flex-1">
            {croppingPatternReports.map((cropReport) => (
              <div
                key={cropReport.crop.persianName}
                className="h-[60px] relative rounded-md overflow-hidden bg-gradient-to-r from-president to-[#793CBA]"
                style={{ width: `${cropReport.compositeIndex * 100}%` }}
              >
                <span className="absolute inset-0 flex items-center justify-center text-white font-bold text-[16px] !font-[B-Nazanin]">
                  {cropReport.compositeIndex.toFixed(2)}
                </span>
              </div>
            ))}
          </div>

          <div className="w-px h-full bg-president" />

          <div className="flex flex-col justify-between h-full text-sm font-medium text-gray-800">
            {croppingPatternReports.map((cropReport) => (
              <div
                key={cropReport.crop.persianName}
                className="h-12 flex items-center"
              >
                <p className="text-[18px] !font-[B-Nazanin] font-bold">
                  {cropReport.crop.persianName}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className=" w-full flex flex-col justify-center items-center mt-8">
          <Title> شاخص ترکیبی الگوی کشت برای محصولات منتخب</Title>
        </div>
      </div>
    </ReportTemplate>
  );
};

export default CompositeIndex;
